import React from "react";
import { Dialog } from "primereact/dialog";

import "./style.scss";

const isMobile = window.innerWidth <= 600;

function HelperImgDialog({ visible = false, setVisible = () => { }, img = "" }) {
  if (window.innerWidth <= 600) {
  }
  return (
    <Dialog
      visible={visible}
      position={isMobile ? "bottom" : "center"}
      maximizable
      onHide={() => setVisible(false)}
      className="helperimgdialog"
    >
      <div className="helperimgdialog_div">
        <img src={img} alt="helper" />
      </div>
    </Dialog>
  );
}

export default HelperImgDialog;
